import { useTranslation } from "react-i18next";
import { Navigation, X, Radar } from "lucide-react";
import { Badge } from "../ui/badge";

/**
 * Title row for the SafeRoutePanel — wordmark + optional LIVE badge with a
 * distance-to-destination readout, and a close button when supplied.
 */
export default function SafeRouteHeader({ liveOn, reChecking, distanceToDestM, onClose }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-1.5">
        <Navigation className="w-3.5 h-3.5 text-gray-700" />
        <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-gray-700">{t("safe_route.title")}</p>
        {liveOn && (
          <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100 text-[9px] rounded-sm px-1 py-0 ml-1 inline-flex items-center gap-1" data-testid="safe-route-live-badge">
            <Radar className={`w-2.5 h-2.5 ${reChecking ? "animate-spin" : ""}`} /> {t("location.live").toUpperCase()}
            {typeof distanceToDestM === "number" && (
              <span className="ml-1 font-mono" data-testid="safe-route-distance">
                {distanceToDestM < 1000 ? `${distanceToDestM} m` : `${(distanceToDestM / 1000).toFixed(1)} km`}
              </span>
            )}
          </Badge>
        )}
      </div>
      {onClose && (
        <button onClick={onClose} className="text-gray-400 hover:text-gray-700" data-testid="safe-route-close" aria-label={t("common.close")}>
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}
